import nodeClient from "./node-client";
export const searchDistributor = async (query = "") => {
  const response = await nodeClient.get(
    `/service/private/v0/distributor/search/by/name?${encodeURI(query)}`
  );
  return response?.data?.result;
};

export const saveDistributor = async (formdata) => {
  const response = await nodeClient.post(
    `/service/private/v0/distributor/save`,
    formdata
  );
  return response?.data;
};

